import { useState, useRef, useEffect } from 'react';
import styles from './HeroSection.module.css';
import HeroVisual from './HeroVisual';
import HeroContent from './HeroContent';
import HeroCTAGroup from './HeroCTAGroup';

function getSpotlightSize(width) {
  if (width <= 400) return 60;
  if (width <= 560) return 76;
  if (width <= 720) return 95;
  if (width <= 900) return 112;
  if (width <= 1100) return 126;
  return 140;
}

function HeroSection({ data, onCTAClick }) {
  const [showScroll, setShowScroll] = useState(false);
  const [spotlightPos, setSpotlightPos] = useState(null);
  const [spotlightSize, setSpotlightSize] = useState(140);
  const sectionRef = useRef(null);

  useEffect(() => {
    function updateSize() {
      setSpotlightSize(getSpotlightSize(window.innerWidth));
    }
    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setShowScroll(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) setShowScroll(false);
      else setShowScroll(true);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function handleWordHover(info) {
    if (!info) return; // null이면 무시 — 기본 위치는 HeroTitle에서 이미 전달
    setSpotlightPos({ x: info.x, y: info.y });
  }

  return (
    <section
      ref={sectionRef}
      className={styles.heroSection}
    >
      {/* 스포트라이트 이미지 — 텍스트 아래 레이어 */}
      <HeroVisual spotlightPos={spotlightPos} size={spotlightSize} />

      {/* 텍스트 */}
      <div className={styles.container}>
        <HeroContent
          title={data.title}
          subtitle={data.subtitle}
          cta={data.cta}
          onCTAClick={onCTAClick}
          onWordHover={handleWordHover}
          hideCTA
        />
      </div>

      {/* 버튼 */}
      <div className={styles.ctaLayer}>
        <HeroCTAGroup
          primary={data.cta.primary}
          secondary={data.cta.secondary}
          onPrimaryClick={onCTAClick}
          onSecondaryClick={onCTAClick}
        />
      </div>

      {/* Scroll Down */}
      <div className={`${styles.scrollDown} ${showScroll ? styles.scrollDownVisible : ''}`}>
        <span className={styles.scrollDownText}>scroll down</span>
        <div className={styles.scrollDownLine} />
      </div>
    </section>
  );
}

export default HeroSection;
